<form name="oncehubForm" method="POST" id="targetHub" target="oncehubPopup" ng-form-commit abcnovalidate>
    <div class="modal-content modal-scheduleonce">
        <div>
            <span class="heading-scheduleonce float-start">Schedule A Meeting</span>
            <button type="button" class="modal-closebtn" aria-label="Close" data-dismiss="modal"
                data-testid="modals.schedule-once.close-btn" (click)="closeModal()">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div>
            <iframe [src]="safeScheduleonceUrl" name="oncehubPopup" class="iframe-scheduleonce"></iframe><br>
        </div>
    </div>
</form>
